<template>
  <section :id="$style.about_visual">
    <div :id="$style.title">
      <main-title
        v-observe-visibility="visibilityChanged_title"
        :class="{[$style.position]: true, ['animated slideInDown']: isVisible_title}"
        :main_title="'ミュージアムについて'"
        :sub_title="'About museum'"
        :color="'#fff'"
      ></main-title>
      <div
        v-observe-visibility="visibilityChanged_explain"
        :id="$style.explain"
        :class="{['animated slideInUp']: isVisible_explain}"
      >
        このミュージアムは、松井秀喜の野球への
        熱い思いと野球を通して 「夢」を追いかけ
        続けることの大切さをテーマに創設しました。
      </div>
      <div :class="$style.fig1"></div>
      <div :class="$style.fig2"></div>
      <div :class="$style.fig3"></div>
    </div>
    <more-info-big-button
      v-observe-visibility="visibilityChanged_btn"
      :class="{[$style.position_btn]: true, ['animated slideInUp']: isVisible_btn}"
      :title="'More Info'"
      :link="'/about/1'"
      :color="'#fff'"
      :background="'rgba(0, 0, 0, 0.3)'"
    ></more-info-big-button>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import MoreInfoBigButton from "@/components/atoms/MoreInfoBigButton.vue";

export default Vue.extend({
  name: "AboutHomeVisual",

  components: {
    MainTitle,
    MoreInfoBigButton
  },
  data() {
    return {
      isVisible_title: Boolean,
      isVisible_explain: Boolean,
      isVisible_btn: Boolean,
      width: window.innerWidth
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.$store.commit("handleResize"));
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    getWindowSize() {
      // return this.$store.state.width < 1023;
      return this.width <= 1023;
    }
  },
  methods: {
    visibilityChanged_title(isVisible) {
      this.isVisible_title = isVisible;
    },
    visibilityChanged_explain(isVisible) {
      this.isVisible_explain = isVisible;
    },
    visibilityChanged_btn(isVisible) {
      this.isVisible_btn = isVisible;
    },
    handleResize: function() {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $color: #fff;
  #about_visual {
    height: 100vh;
    background-color: #000;
    // 中央寄せ
    display: flex;
    align-items: center;
    justify-content: center;
    // 縦に積む
    flex-direction: column;
    flex-wrap: wrap;
    position: relative;
    z-index: 0;
    overflow: hidden;
    #title {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 80px;
      flex-direction: column;
      flex-wrap: wrap;
      z-index: 1;
      position: relative;
      width: 300px;
      .position {
        text-align: center;
        z-index: 1;
      }
      #explain {
        color: $color;
        width: 240px;
        text-align: left;
        font-size: 19px;
        margin-top: 50px;
        z-index: 1;
      }
    }
    .position_btn {
      z-index: 1;
      position: relative;
    }
    #about_pannel {
      height: 200px;
      width: 300px;
      background-color: #000;
      display: flex;
      .half {
        color: $color;
        font-size: 100px;
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex-wrap: wrap;
        text-decoration: none;
        border: 1px solid #333333;
        p {
          font-size: 20px;
          margin-left: 40px;
        }
      }
    }
    .fig1 {
      background-image: url("../../../assets/img/history/L1.jpg");
      background-size: 400px 400px;
      background-repeat: no-repeat;
      height: 400px;
      width: 400px;
      position: absolute;
      z-index: 0;
      top: 0px;
      right: -65px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  $color: #fff;
  #about_visual {
    height: 100vh;
    background-color: #000;
    // 中央寄せ
    display: flex;
    align-items: center;
    justify-content: center;
    // 縦に積む
    flex-direction: column;
    flex-wrap: wrap;
    position: relative;
    z-index: 0;
    overflow: hidden;
    #title {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      z-index: 1;
      position: relative;
      width: 900px;
      height: 500px;
      .position {
        text-align: center;
        z-index: 1;
      }
      #explain {
        color: $color;
        width: 440px;
        text-align: left;
        font-size: 19px;
        position: absolute;
        bottom: 30px;
        right: 50px;
        z-index: 1;
      }
    }
    .position_btn {
      z-index: 1;
      position: relative;
      margin-left: 350px;
    }
    .fig1 {
      background-image: url("../../../assets/img/history/L1.jpg");
      background-size: 500px 500px;
      background-repeat: no-repeat;
      height: 500px;
      width: 500px;
      position: absolute;
      z-index: 0;
      right: 0px;
    }
    .fig2 {
      background-image: url("../../../assets/img/medal/R3.png");
      background-size: 70px 70px;
      background-repeat: no-repeat;
      height: 70px;
      width: 70px;
      position: absolute;
      z-index: 0;
      bottom: 30px;
      left: 36px;
    }
    .fig3 {
      background-image: url("../../../assets/img/medal/R3_1.png");
      background-size: 120px 324px;
      background-repeat: no-repeat;
      height: 324px;
      width: 120px;
      position: absolute;
      z-index: 0;
      bottom: 0px;
      left: 170px;
    }
  }
}
</style>
